import React from 'react';

/**
 * AeroDotLoader: the logo's blue dot as the loading sign (decided 23 Oct
 * 2026: "the dot can become the loader"). A single dot that breathes; under
 * reduced motion it stays still. Styles: .aero-dot-loader in
 * aero-components.css.
 *
 * Props: size ('sm' | 'md' | 'lg'), label (screen-reader text, default
 * "Loading"; pass null when a visible label already says it).
 */
export default function AeroDotLoader({ size = 'md', label = null, className = '' }) {
  return (
    <span
      className={`aero-dot-loader aero-dot-loader-${size} ${className}`.trim()}
      role={label ? 'status' : undefined}
      aria-label={label || undefined}
      aria-hidden={label ? undefined : true}
    />
  );
}
